import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { LoadingSpinerLocal, ModalPriceEventHistory } from '../../../../../../components';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { selectorContextMenu } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { selectorPriceEventHistory, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/priceEventHistory';
import { getPriceEventHistory } from '../../../services_ts';

type PriceEventHistoryModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const PriceEventHistoryModalWrapper = ({ priceEventHistory: { isOpen }, contextMenuDatapoint, closeModal }: PriceEventHistoryModalWrapperProps) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'price-composition' });
  if (!contextMenuDatapoint) return null;

  if (promiseInProgress) {
    return <LoadingSpinerLocal loading={promiseInProgress} size="md" height="100%" position="absolute" />;
  }

  const queryFn = async () => {
    try {
      const response = getPriceEventHistory(contextMenuDatapoint.productsToBePricedId);
      if (!response) throw new Error('Falha ao obter resumo de alteração de preço');
      return response;
    } catch (err) {
      throw AlertWithTimestamp({ message: err.message });
    }
  };

  return <ModalPriceEventHistory show={isOpen} onHide={closeModal} queryFn={queryFn} productsToBePricedId={contextMenuDatapoint.productsToBePricedId} />;
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
  priceEventHistory: selectorPriceEventHistory(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceEventHistoryModalWrapper);
